<template>
  <v-app>
    <v-main>
      <MainHeader @clickHeaderButton="clickHeaderButton"></MainHeader>
      <v-divider></v-divider>
      <p v-show="mode=='search'" class="search-result my-4">あなたと相性の良い{{view_profiles.length}}人の{{ getSexialOrient() }}が見つかりました。</p>
      <p v-show="mode=='like'" class="search-result my-4">あなたは{{view_profiles.length}}人の{{ getSexialOrient() }}にいいねをしています。</p>
      <p v-show="mode=='chat'" class="search-result my-4">あなたは{{view_profiles.length}}人の{{ getSexialOrient() }}とマッチングしています。</p>
      <p v-show="mode=='setting'" class="search-result my-4">あなたのプロフィールです。</p>
      <v-divider></v-divider>

      <v-card
        v-show="mode!='setting'"
        flat
        class="mx-auto"
        v-for="(profile, i) in view_profiles"
        :key="i"
      >
        <v-container>
          <v-row dense>
            <v-col cols="3">
              <v-img v-bind:src="'img/' + profile.pic"></v-img>
            </v-col>
            <v-col cols="9">
              <p class="profile_name font-weight-bold">{{profile.name}}さん（{{profile.age}}歳）</p>
              <p class="profile_detail">
                価値観 <v-chip size="small" class="mb-1" color="pink" text-color="white">{{profile.type}}</v-chip>
                <v-row no-gutters>
                  <v-col cols="12" sm="6" class="text-caption">
                    居住地 <v-chip size="small" class="mb-1">{{profile.pref}}</v-chip>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption">
                    職業 <v-chip size="small" class="mb-1">{{profile.job}}</v-chip>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" sm="6" class="text-caption">
                    最終学歴 <v-chip size="small" class="mb-1">{{profile.education}}</v-chip>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption">
                    年収 <v-chip size="small" class="mb-1">{{profile.income}}</v-chip>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" sm="6" class="text-caption">
                    身長 <v-chip size="small" class="mb-1">{{profile.height}}cm</v-chip>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption">
                    体型 <v-chip size="small" class="mb-1">{{profile.bodyshape}}</v-chip>
                  </v-col>
                </v-row>
                趣味
                <v-chip
                  v-for="(h, i) in profile.hobby.split(',')"
                  :key="i"
                  class="mb-1 mr-1" size="small"
                >
                  {{h}}
                </v-chip>
              </p>
            </v-col>
          </v-row>

          <div class="bg-grey-lighten-4 ma-0 mt-1">
            <p
              v-show="!profile_text_expand[i]"
              style="height:3em;"
              class="mx-2 mt-2 pt-1 profile_text overflow-hidden"
              @click="profile_text_expand[i] = !profile_text_expand[i]"
            >
              {{profile.text.replace(/<br>/g,"")}}
            </p>
            <v-btn block
              v-show="!profile_text_expand[i]"
              size="x-small"
              variant="plain"
              class="text-caption"
              @click="profile_text_expand[i] = !profile_text_expand[i]"
            >
              <span class="text-caption">もっと読む</span>
            </v-btn>

            <v-expand-transition>
              <p v-show="profile_text_expand[i]" class="ma-2 profile_text py-1" v-html="profile.text.replace(/<br>/g,'<br>')" />
            </v-expand-transition>
          </div>
          
          <v-btn 
            v-bind:class="checkLike(profile.id)?'mt-1':'bg-pink text-white mt-1'"
            block
            v-bind:variant="checkLike(profile.id)?'outlined':'elevated'"
            v-bind:color="checkLike(profile.id)?'pink':'white'"
            v-bind:elevation="checkLike(profile.id)?0:2"
            v-on:click="clickLike(profile.id)"
          ><v-icon>mdi-cards-heart</v-icon>いいね<span v-if="checkLike(profile.id)">をやめる</span></v-btn>
        </v-container>
      </v-card>

      <v-container v-show="mode=='search' && type.type_id==0">
        <a style="cursor: pointer;" @click="mode='setting';$refs.mySelf.runIdentify();"><v-img src="img/kachikan_banner.png" ></v-img></a>
      </v-container>

      <v-container v-show="mode=='setting'">
        <MyselfSetting ref="mySelf" :is_first_visit="is_first_visit" @setFirstVisit="setFirstVisit" @setMyProfile="setMyProfile">></MyselfSetting>
      </v-container>

    </v-main>
  </v-app>
</template>

<style>
*{
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-17)/var(--unnamed-line-spacing-26) var(--unnamed-font-family-hiragino-kaku-gothic-pro);
}

.search-result{
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-17)/var(--unnamed-line-spacing-26) var(--unnamed-font-family-hiragino-kaku-gothic-pro);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--standard-gray);
  text-align: center;
  opacity: 1;
}

.profile_name{
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-17)/var(--unnamed-line-spacing-26) var(--unnamed-font-family-hiragino-kaku-gothic-pro);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--standard-gray);
  text-align: left;
  opacity: 1;
}

.profile_detail{
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-hiragino-kaku-gothic-pro);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--standard-gray);
  text-align: left;
  opacity: 1;
}

.profile_text{
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-hiragino-kaku-gothic-pro);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--kuro);
  text-align: left;
  opacity: 1;
}
</style>

<script>
import MainHeader from './components/MainHeader.vue'
import MyselfSetting from './components/MyselfSetting.vue'
//import { onMounted } from 'vue'

export default {
  name: 'App',

  components: {
    MainHeader,
    MyselfSetting,
  },

  data: () => ({
    profiles : [],
    view_profiles : [],
    likes : new Set([]),
    mode : null,
    is_first_visit : true,
    my_profile : {},
    type : null,
    profile_text_expand : [],
  }),

  methods: {
    clickLike(id){
      if(this.checkLike(id)){
        this.likes.delete(id);
      }else{
        this.likes.add(id);
      }
      localStorage.likes =  Array.from(this.likes);
      //console.log(localStorage.likes)
      
    },
    checkLike(id){
      if(this.likes.has(id)){
        return true;
      }else{
        return false;
      }
    },
    clickHeaderButton(type){
      switch(type){
        case 'search':
          console.log(this.profiles);
          this.view_profiles = this.profiles.filter(p => p['sex']!=this.my_profile['sex'] )
                                            .filter(p => (this.type['type_name']=="プライバシーがいちばんタイプ") ? p['type']==this.type['type_name']:p['type']!='プライバシーがいちばんタイプ');
          
          this.profile_text_expand = [];
          for(let i=0; i<this.view_profiles.length; i++){
            this.profile_text_expand.push(false);
          }
          this.mode = 'search';
          break;

        case 'like':
          this.view_profiles = this.profiles.filter(p => this.checkLike(p.id) )
          
          this.profile_text_expand = [];
          for(let i=0; i<this.view_profiles.length; i++){
            this.profile_text_expand.push(false);
          }
          this.mode = 'like';
          break;

        case 'chat':
          this.view_profiles = [];
          this.mode = 'chat';
          break;
        
        case 'setting':
          this.mode = 'setting';
          break;
      }
    },
    filter(conditions){
      this.view_profiles = this.profiles;
      for(const c in conditions){
        this.view_profiles = this.view_profiles.filter(p => p[c]==conditions[c]);
      }
    },
    getSexialOrient(){
      if(this.my_profile["sex"]=="女性"){
        return "男性";
      }else{
        return "女性";
      }
    },
    setFirstVisit(b){
      this.is_first_visit = b; 
    },
    setMyProfile(my_profile, type){
      this.my_profile = my_profile;
      this.type = type;
      this.clickHeaderButton('search');
    }
  },

  created() {
    if(localStorage.likes){
      this.likes = new Set(localStorage.likes.split(','));
      //console.log(this.likes);
    }
  },

  mounted() {
    fetch('https://sheets.googleapis.com/v4/spreadsheets/1wREH8JqHMzLZQuiVt2rJcZLO0bxmg4jGZslaI_DIS6I/values/profile?key=AIzaSyC5hzXBPv-t-6gaB3ALDHuGH0SAYrfWWIk')
      .then(res => res.json())
      .then(res => {
        const columns = res.values[0];
        const values = res.values.slice(1);
        for (const v in values){
          let profile = {};
          for(const c in columns){
            profile[columns[c]] = values[v][c];
          }

          this.profiles.push(profile);
        }

        if(this.is_first_visit){
          if(localStorage.profile){
            this.is_first_visit = false;
            this.clickHeaderButton('search');
          }else{
            this.clickHeaderButton('setting');
          }
        }
      })
      .catch(
        error => {
          console.log(error)
        }
    );
  },
}
</script>
